<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Staff</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">About</a></span>
                                        </div>
                                        <span>Staff</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <section class="bd-teacher-area pt-120 pb-80">
            <div class="container">
                <div class="row" id="staff_details">
                    <div v-for="(item, index) in data" :key="index" class="col-xl-3 col-lg-4 col-sm-6">
                        <div>
                            <div class="bd-teacher mb-40 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                <a href="#">
                                    <div class="bd-teacher-thumb">
                                        <img :src="item.photo" alt="Image not found">
                                    </div>
                                </a>
                                <div class="bd-teacher-content-wrapper">
                                    <div class="bd-teacher-content">
                                        <h4 class="bd-teacher-title">
                                            <a>'{{ item.name }}'</a>
                                        </h4>
                                        <span class="bd-teacher-des">'{{ item.designation }}'</span>
                                    </div>
                                    <div class="bd-teacher-social"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </main>
</template>
<script>
export default {
    name: "StaffView",
    data() {
        return {
            data: null,
        };
    },
    methods: {
        async fetchData() {

            const responseValue = await fetch("json/staffx.json");
            this.data = await responseValue.json();
        }
    },
    mounted() {
        this.fetchData();
    },
};
</script>
